import styled from '@emotion/styled';

export const DisabledOverlay = styled.div`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: var(--element-disabled-opacity);
  z-index: var(--zindex-elevated);
`;
